"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const community_1 = require("@aurora/shared-types/community");
const exenv_1 = require("exenv");
const cookie_1 = __importDefault(require("cookie"));
const asynchronous_local_storage_1 = require("asynchronous-local-storage");
const log_1 = require("../log");
const log = (0, log_1.getLog)(module);
const AUTH_COOKIE_PREFIXES = ['LiSESSIONID', 'apiAuth_', 'auroraAuthentication'];
const anonymizeHeaders = [
    'authorization',
    'x-forwarded-for',
    'x-forwarded-host',
    'x-forwarded-proto',
    'x-forwarded-port',
    'x-forwarded-server'
];
const alwaysFilterHeaders = ['origin', 'access-control-', 'sec-fetch-', 'content-'];
/**
 * A helper class for origin requests.
 */
class OriginHelper {
    static isAuthCookie(cookieName) {
        for (const authCookiePrefix of AUTH_COOKIE_PREFIXES) {
            if (cookieName.startsWith(authCookiePrefix)) {
                return true;
            }
        }
        return false;
    }
    static filterAuthCookies(cookieHeader) {
        if (cookieHeader) {
            const parsedCookies = cookie_1.default.parse(cookieHeader);
            const filteredCookies = [];
            for (const cookieName of Object.keys(parsedCookies)) {
                if (!this.isAuthCookie(cookieName)) {
                    filteredCookies.push(cookie_1.default.serialize(cookieName, parsedCookies[cookieName]));
                }
            }
            return filteredCookies.join('; ').trim();
        }
        return cookieHeader;
    }
    static isAlwaysFilteredHeader(header) {
        return alwaysFilterHeaders.some(alwaysFilterHeader => header.startsWith(alwaysFilterHeader));
    }
    static filterHeaders(headers, filteredHeaders, includeHeaders) {
        return Object.fromEntries(Object.entries(headers).filter(([key]) => {
            const normalizedKey = key.toLowerCase();
            return ((!OriginHelper.isAlwaysFilteredHeader(normalizedKey) &&
                !filteredHeaders.includes(normalizedKey)) ||
                includeHeaders.includes(normalizedKey));
        }));
    }
    /**
     * Get the origin headers from the current request, if any.
     */
    static getOriginHeaders(anonymize, includeHeaders = []) {
        var _a, _b;
        if (exenv_1.canUseDOM) {
            return {};
        }
        const originHeaders = (_a = asynchronous_local_storage_1.als === null || asynchronous_local_storage_1.als === void 0 ? void 0 : asynchronous_local_storage_1.als.get(community_1.ContextKeys.originHeaders)) !== null && _a !== void 0 ? _a : {};
        if (anonymize) {
            const anonymizedHeaders = OriginHelper.filterHeaders(originHeaders, anonymizeHeaders, includeHeaders);
            const clonedHeaders = Object.assign({}, anonymizedHeaders);
            if (!includeHeaders.includes('cookie')) {
                const authCookie = this.filterAuthCookies((_b = clonedHeaders.cookie) !== null && _b !== void 0 ? _b : clonedHeaders.Cookie);
                if (authCookie) {
                    clonedHeaders['cookie'] = authCookie;
                }
            }
            log.trace('Anonymized origin headers are %O', clonedHeaders);
            return clonedHeaders;
        }
        else {
            const headers = OriginHelper.filterHeaders(originHeaders, [], []);
            log.trace('Origin headers are %O', headers);
            return headers;
        }
    }
    /**
     * Are there origin headers on the current request?
     */
    static hasOriginHeaders() {
        return exenv_1.canUseDOM ? false : (asynchronous_local_storage_1.als === null || asynchronous_local_storage_1.als === void 0 ? void 0 : asynchronous_local_storage_1.als.get(community_1.ContextKeys.originHeaders)) != null;
    }
}
exports.default = OriginHelper;
//# sourceMappingURL=OriginHelper.js.map